/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_Ent_Feat2Inputs */

const en_mk_price_ent_feat2 = /** @type {(inputs: Mk_Price_Ent_Feat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DPA, SLA, priority support`)
};

const id_mk_price_ent_feat2 = /** @type {(inputs: Mk_Price_Ent_Feat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DPA, SLA, dukungan prioritas`)
};

/**
* | output |
* | --- |
* | "DPA, SLA, priority support" |
*
* @param {Mk_Price_Ent_Feat2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_ent_feat2 = /** @type {((inputs?: Mk_Price_Ent_Feat2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_Ent_Feat2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_ent_feat2(inputs)
	return en_mk_price_ent_feat2(inputs)
});